import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TiposCliente from '../components/TiposCliente';
import ConsultaMultas from '../components/ConsultaMultas';
import ComoFunciona from '../components/ComoFunciona';
import SobreNosotros from '../components/SobreNosotros';
import Tips from '../components/Tips';
import Promocional from '../components/Promocional';
import Contacto from '../components/Contacto';
import Footer from '../components/Footer';
function Home() {
  return (
    <div>
      <Header />
      <Hero />
      <ComoFunciona />
      <TiposCliente />
      <ConsultaMultas />
      <SobreNosotros />
      <Tips />
      <Promocional />
      <Contacto />
      <Footer />
    </div>
  );
}

export default Home;

